(() => {
  const SELECTOR = '[data-mbb-professionals-hero]';

  class MbbProfessionalsHero {
    constructor(section) {
      if (!section || section.dataset.mbbProInitialized === 'true') return;

      this.section = section;
      this.image = section.querySelector('.mbb-professionals-hero__image');
      this.visible = false;
      this.frame = null;
      this.reducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);

      this.init();
    }

    init() {
      this.section.dataset.mbbProInitialized = 'true';

      if (
        this.reducedMotion ||
        !('IntersectionObserver' in window)
      ) {
        this.visible = true;
        this.section.classList.add('is-visible');
        return;
      }

      this.observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            this.visible = entry.isIntersecting;

            if (entry.isIntersecting) {
              this.section.classList.add('is-visible');
              this.updateParallax();
            }
          });
        },
        {
          threshold: 0.15,
          rootMargin: '0px 0px -8% 0px'
        }
      );

      this.observer.observe(this.section);

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });
    }

    onScroll() {
      if (!this.visible || this.frame) return;

      this.frame = requestAnimationFrame(() => {
        this.updateParallax();
        this.frame = null;
      });
    }

    onResize() {
      if (this.frame) cancelAnimationFrame(this.frame);

      this.frame = requestAnimationFrame(() => {
        this.updateParallax();
        this.frame = null;
      });
    }

    updateParallax() {
      if (!this.image || this.reducedMotion) return;

      const rect = this.section.getBoundingClientRect();
      const viewport = window.innerHeight;
      const progress = Math.max(
        -1,
        Math.min(1, (viewport / 2 - rect.top) / viewport)
      );

      this.image.style.setProperty(
        '--mbb-pro-parallax',
        `${progress * 14}px`
      );
    }

    destroy() {
      this.observer?.disconnect();

      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);

      if (this.frame) cancelAnimationFrame(this.frame);

      this.section.classList.remove('is-visible');
      this.image?.style.removeProperty('--mbb-pro-parallax');

      delete this.section.dataset.mbbProInitialized;
    }
  }

  const getSections = root => {
    if (root.matches?.(SELECTOR)) return [root];

    return [...(root.querySelectorAll?.(SELECTOR) || [])];
  };

  const init = root => {
    getSections(root).forEach(section => {
      if (section.dataset.mbbProInitialized === 'true') return;

      section.mbbProfessionalsHero = new MbbProfessionalsHero(section);
    });
  };

  const start = () => init(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', event => {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', event => {
    getSections(event.target).forEach(section => {
      section.mbbProfessionalsHero?.destroy();
      delete section.mbbProfessionalsHero;
    });
  });
})();